import axios from "axios";
import toast from "react-hot-toast";
import { config } from "../../Utils/helpers";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getSurroundingIndustriesList = (industriesData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_SURROUNDING_INDUSTRIES_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/surrounding-industries/list`,
        industriesData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_SURROUNDING_INDUSTRIES_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_SURROUNDING_INDUSTRIES_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_SURROUNDING_INDUSTRIES_LIST_FAILED",
        payload: error?.data?.response?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addSurroundingIndustry = (industriesData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });

    try {
      dispatch({ type: "ADD_SURROUNDING_INDUSTRY_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/surrounding-industries/add`,
        industriesData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_SURROUNDING_INDUSTRY_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_SURROUNDING_INDUSTRY_FAILED", payload: data });
        toast.error("Something Went Wrong!!");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_SURROUNDING_INDUSTRY_FAILED",
        payload: error?.data?.response?.message,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
